import { neutral } from '@bloomfieldrobotics/canopy';
import { Box, Stack, Typography } from '@mui/material';

type Props = {
  items: {
    color: string | undefined;
    label: string;
  }[];
};

export const ReportChartLegend = ({ items }: Props) => {
  return (
    <Stack
      direction='row'
      alignItems='center'
      sx={{
        width: '100%',
        flexWrap: 'wrap',
        gap: 3,
      }}
    >
      {items.map((item) => (
        <Stack
          key={item.label}
          direction='row'
          sx={{ alignItems: 'center', gap: 1 }}
        >
          <Box
            sx={{
              height: '0.5rem',
              width: '0.5rem',
              borderRadius: '0.125rem',
              backgroundColor: item.color || neutral[700],
            }}
          />
          <Typography variant='caption'>{item.label}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};
